import { ColumnDef } from '@tanstack/react-table';

import { SimpleTooltip } from '@eluve/components';
import { SortableColumnHeader, Stack, Text } from '@eluve/components';

export interface ModelArgsColDefProps {
  modelArgs: {
    id: string;
    args: Record<string, any> | null;
  } | null;
}

export const ModelArgsColDef = <
  T extends ModelArgsColDefProps,
>(): ColumnDef<T> => ({
  accessorKey: 'modelArgs',
  accessorFn: (row) => JSON.stringify(row.modelArgs?.args ?? {}),
  header: ({ column }) => (
    <SortableColumnHeader column={column} label="Model args" />
  ),
  cell: ({ row }) => {
    const model = row.original.modelArgs;
    if (!model || !model.args) {
      return <Text color="disabled">No summary generated.</Text>;
    }

    return (
      <SimpleTooltip label={`id: ${model.id}`}>
        <Stack className="text-text-secondary" gap={1} align="stretch">
          {Object.entries(model.args).map(([key, value]) => (
            <div key={key}>
              <strong>{key}</strong>: {JSON.stringify(value)}
            </div>
          ))}
        </Stack>
      </SimpleTooltip>
    );
  },
});
